import { render } from "./SummaryReportsList.vue?vue&type=template&id=587a6314&scoped=true"
import script from "./SummaryReportsList.vue?vue&type=script&lang=js"
export * from "./SummaryReportsList.vue?vue&type=script&lang=js"

import "./SummaryReportsList.vue?vue&type=style&index=0&id=587a6314&scoped=true&lang=scss"

import exportComponent from "/Users/ramazansapar/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-587a6314"]])

export default __exports__